<div class="respo-scroll badal_scroll">
   <ng-container *ngIf="accessApproval == true">
      <table class="default-table-style">
         <thead>
            <tr>
               <th class="text-left">Symbol</th>
               <!-- <th class="text-center">Badla[BUY]</th>
               <th class="text-center">Badla[SELL]</th> -->
               <th class="text-center">Badla</th>
               <th class="text-center">Next Badla</th>
               <th class="text-center">COMEXBID</th>
               <th class="text-center">COMEXASK</th>
               <th class="text-center">MCX BID</th>
               <th class="text-center">MCX ASK</th>
               <th class="text-center">DGCX BID</th>
               <th class="text-center">DGCX ASK</th>
               <th class="text-center">COMEX HIGH</th>
               <th class="text-center">COMEX LOW</th>
               <th class="text-center">MCX HIGH</th>
               <th class="text-center">MCX LOW</th>
               <th class="text-center">Detail</th>

            </tr>
         </thead>
         <tbody>
            <ng-container *ngIf="allScript.length > 0">
               <tr *ngFor="let binstu of allScript; let i = index;">
                  <input type="hidden" id="{{binstu._id}}_prev_finalBadla">
                  <td class="text-left type_main">
                     {{(binstu.displayName) ? binstu.displayName : binstu.badlaType }}

                  </td>
                  <!-- <td class="text-center" id="sell_{{binstu._id}}"></td>
                  <td class="text-center" id="buy_{{binstu._id}}"></td> -->
                  <td class="text-center" id="{{binstu._id}}"></td>
                  <td class="text-center" id="{{binstu._id}}_next"></td>
                  <td class="text-center"
                     id="{{binstu.instrumentsDetail[1].instrument_token}}_{{binstu._id}}_badla_buyP_bg"><span
                        id="{{binstu.instrumentsDetail[1].instrument_token}}_{{binstu._id}}_badla_buyP">0</span> </td>
                  <td class="text-center"
                     id="{{binstu.instrumentsDetail[1].instrument_token}}_{{binstu._id}}_badla_sellP_bg"><span
                        id="{{binstu.instrumentsDetail[1].instrument_token}}_{{binstu._id}}_badla_sellP">0</span></td>

                  <td class="text-center"
                     id="{{binstu.instrumentsDetail[0].instrument_token}}_{{binstu._id}}_badla_buyP_bg">
                     <p id="{{binstu.instrumentsDetail[0].instrument_token}}_{{binstu._id}}_badla_buyP">0</p>
                     <!-- <p id="{{binstu.instrumentsDetail[0].instrument_token}}_{{binstu._id}}_badla_dollerBuy" class="mcx-doller-rate">0</p> -->
                  </td>
                  <td class="text-center"
                     id="{{binstu.instrumentsDetail[0].instrument_token}}_{{binstu._id}}_badla_sellP_bg">
                     <p id="{{binstu.instrumentsDetail[0].instrument_token}}_{{binstu._id}}_badla_sellP">0</p>
                     <!-- <p id="{{binstu.instrumentsDetail[0].instrument_token}}_{{binstu._id}}_badla_dollerSell" class="mcx-doller-rate">0</p> -->
                  </td>
                  <td class="text-center"
                     id="{{binstu.instrumentsDetail[2].instrument_token}}_{{binstu._id}}_badla_buyP_bg">
                     <p id="{{binstu.instrumentsDetail[2].instrument_token}}_{{binstu._id}}_badla_buyP">0</p>
                     <!-- <p id="{{binstu.instrumentsDetail[0].instrument_token}}_{{binstu._id}}_badla_dollerBuy" class="mcx-doller-rate">0</p> -->
                  </td>
                  <td class="text-center"
                     id="{{binstu.instrumentsDetail[2].instrument_token}}_{{binstu._id}}_badla_sellP_bg">
                     <p id="{{binstu.instrumentsDetail[2].instrument_token}}_{{binstu._id}}_badla_sellP">0</p>
                     <!-- <p id="{{binstu.instrumentsDetail[0].instrument_token}}_{{binstu._id}}_badla_dollerSell" class="mcx-doller-rate">0</p> -->
                  </td>
                  <td class="text-center credit-color-bg" >
                     <p id="{{binstu.instrumentsDetail[1].instrument_token}}_{{binstu._id}}_comex_high">0</p>
                     <!-- <p id="{{binstu.instrumentsDetail[0].instrument_token}}_{{binstu._id}}_badla_dollerSell" class="mcx-doller-rate">0</p> -->
                  </td>
                  <td class="text-center debit-color-bg">
                     <p id="{{binstu.instrumentsDetail[1].instrument_token}}_{{binstu._id}}_comex_low">0</p>
                     <!-- <p id="{{binstu.instrumentsDetail[0].instrument_token}}_{{binstu._id}}_badla_dollerSell" class="mcx-doller-rate">0</p> -->
                  </td>
                  <td class="text-center credit-color-bg">
                     <p id="{{binstu.instrumentsDetail[0].instrument_token}}_{{binstu._id}}_mcx_high">0</p>
                     <!-- <p id="{{binstu.instrumentsDetail[0].instrument_token}}_{{binstu._id}}_badla_dollerSell" class="mcx-doller-rate">0</p> -->
                  </td>
                  <td class="text-center debit-color-bg">
                     <p id="{{binstu.instrumentsDetail[0].instrument_token}}_{{binstu._id}}_mcx_low">0</p>
                     <!-- <p id="{{binstu.instrumentsDetail[0].instrument_token}}_{{binstu._id}}_badla_dollerSell" class="mcx-doller-rate">0</p> -->
                  </td>
                  <td class="text-center">
                     {{binstu.settingName}}
                  </td>
                  <input type="hidden"
                     id="{{binstu.instrumentsDetail[0].instrument_token}}_{{binstu._id}}_prev_buy_comex">
                  <input type="hidden"
                     id="{{binstu.instrumentsDetail[0].instrument_token}}_{{binstu._id}}_prev_sell_comex">
                  <input type="hidden"
                     id="{{binstu.instrumentsDetail[1].instrument_token}}_{{binstu._id}}_prev_buy_mcx">
                  <input type="hidden"
                     id="{{binstu.instrumentsDetail[1].instrument_token}}_{{binstu._id}}_prev_sell_mcx">
                  <input type="hidden"
                     id="{{binstu.instrumentsDetail[2].instrument_token}}_{{binstu._id}}_prev_buy_dgcx">
                  <input type="hidden"
                     id="{{binstu.instrumentsDetail[2].instrument_token}}_{{binstu._id}}_prev_sell_dgcx">


               </tr>
            </ng-container>

         </tbody>
      </table>
   </ng-container>
   <ng-container *ngIf="accessApproval == false">
      <div class="alert alert-danger" role="alert">
         You can not access this panel.
      </div>
   </ng-container>
</div>